import { Component, input, output } from '@angular/core';

import { FormsModule } from '@angular/forms';

@Component({
  standalone: true,
  imports: [FormsModule],
  selector: 'lib-search-filter',
  template: `
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <div class="flex flex-col sm:flex-row gap-4">
        <!-- Search Input -->
        <div class="flex-1">
          <label for="search" class="sr-only">Search experts</label>
          <div class="relative">
            <div
              class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="h-5 w-5 text-gray-400"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                />
              </svg>
            </div>
            <input
              id="search"
              type="search"
              class="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              placeholder="Search by name, ID, email, or industry..."
              [value]="searchTerm()"
              [disabled]="isLoading()"
              (input)="onSearchInput($event)"
            />
          </div>
        </div>

        <!-- Filter Toggle -->
        <div class="flex items-center space-x-4">
          <label class="flex items-center">
            <input
              type="checkbox"
              class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              [checked]="showOnlySignedIn()"
              [disabled]="isLoading()"
              (change)="onToggleChange()"
            />
            <span class="ml-2 text-sm text-gray-700">Show only signed in</span>
          </label>

          <!-- Reset Button -->
          <button
            type="button"
            class="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-150"
            [disabled]="isLoading() || (!searchTerm() && !showOnlySignedIn())"
            (click)="onReset()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="-ml-1 mr-2 h-4 w-4"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
              />
            </svg>
            Reset
          </button>
        </div>
      </div>
    </div>
  `,
})
export class SearchFilterComponent {
  searchTerm = input.required<string>();
  showOnlySignedIn = input.required<boolean>();
  isLoading = input(false);

  searchTermChange = output<string>();
  toggleShowOnlySignedIn = output<void>();
  reset = output<void>();

  onSearchInput(event: Event) {
    const target = event.target as HTMLInputElement;
    this.searchTermChange.emit(target.value);
  }

  onToggleChange() {
    this.toggleShowOnlySignedIn.emit();
  }

  onReset() {
    this.reset.emit();
  }
}
